export default "__VITE_ASSET__3d86a9f3__"